export default __webpack_public_path__ + "static/media/2b2aaea69b8ebe3f.094a434afb311d6970b0a26c54b8fc6c.svg";